
import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  setup() {
    const count = 15;

    const countLength = computed(() => {
      if (count < 6) {
        return count;
      }
      return 5;
    });

    return { count, countLength };
  },
});
